import React, { FC } from 'react'

import { useTheme, Box, alpha } from '@mui/material'
import { isEmpty } from 'lodash'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { chartOptions } from '../chartOptions'
import { EmptyData } from '../EmptyData'
import { Indicators } from '../Indicators'
import { ReportWidgetsHeader } from '../ReportWidgetsHeader'
import { StyledWidgetWrapper } from '../StyledWidgetWrapper'
import { WinLossAmountType } from '../types'

export const WinLossNumberWidget: FC<{
  data: WinLossAmountType[] | undefined
  displayWidth: number
}> = ({ data, displayWidth }) => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()

  const chartData = {
    labels: data?.map((item) => item.period),
    datasets: [
      {
        label: t('wins', 'Wins'),
        data: data?.map((item) => item.win.count),
        backgroundColor: palette.green[400],
        barThickness: 16,
        borderRadius: 4,
        borderColor: palette.primary.light,
        borderWidth: 2,
        hoverBackgroundColor: alpha(palette.green[400] as string, 0.8),
      },
      {
        label: t('losses', 'Losses'),
        data: data?.map((item) => item.loss.count),
        backgroundColor: palette.red[400],
        barThickness: 16,
        borderRadius: 4,
        borderColor: palette.primary.light,
        borderWidth: 2,
        hoverBackgroundColor: alpha(palette.red[400] as string, 0.8),
      },
    ],
  }

  return (
    <StyledWidgetWrapper>
      <ReportWidgetsHeader
        text={t('winVsLossNumberOfTransactions', 'Win vs Loss: number of transactions')}
        explanation={t(
          'theGraphRepresentsTheComparisonOfWinnersVsLosers',
          'The graph represents the comparison of winners vs losers',
        )}
      />

      {isEmpty(data) ? (
        <Box mt={4}>
          <EmptyData />
        </Box>
      ) : (
        <Box ml={spacing(-3)}>
          <Bar
            data={chartData}
            options={chartOptions()}
            style={{ maxHeight: spacing(31) }}
            key={displayWidth}
          />
        </Box>
      )}
      <Indicators positiveLabel={t('win', 'Win')} negativeLabel={t('loss', 'Loss')} />
    </StyledWidgetWrapper>
  )
}
